import React from 'react';
import ReactFC from 'react-fusioncharts';
import FusionCharts from 'fusioncharts';
import Doughnut2D from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';

FusionCharts.options.license({
  key:
    '9fE1jieC7E2B4E2G2E2D1B2B4D1F4D5D3zuH-7B6A6rtzdA-7G2B1hxiB1A4B4E2A15A16A8C9B3A3C5B1C1D3H4A9C-22cC-13E3D4A2uA1C3A4hkE-11G2F4H1xC-22sC8B4E6hppC3A5C6E2C6B1F5F1H3F1B5wE-13yC2A3LC1J-7yhC1C3C1ytG4i1A6B7e1bsB3C2C3C1B2C1B2F6C5E4H1F4I4C4k==',
  creditLabel: false,
});

ReactFC.fcRoot(FusionCharts, Doughnut2D, FusionTheme);

export const FUSION_CHARTS_TYPE = {
  Doughnut2D: 'doughnut2d',
  Pie2D: 'pie2d',
  MSCombiDY2D: 'mscombidy2d',
  MSCombi2D: 'mscombi2d',
  MSStackedColumn2DLineDY: 'msstackedcolumn2dlinedy',
  MSStackedColumn2D: 'msstackedcolumn2d',
  StackedColumn2DLineDY: 'stackedcolumn2dlinedy',
  StackedColumn2DLine: 'stackedcolumn2dline',
  StackedColumn2D: 'stackedcolumn2d',
  StackedArea2DLineDY: 'stackedarea2dlinedy',
  StackedArea2D: 'stackedarea2d',
  StackedBar2D: 'stackedbar2d',
  StackedBar2DWithLine: 'msstackedcolumn2dlinedy',
};

const defaultChartConfigs = {
  type: 'doughnut2d',
  width: '100%',
  dataFormat: 'json',
};

const getChartConfig = ({ chartConfig, height, data }) => {
  return {
    ...defaultChartConfigs,
    height: height,
    dataSource: {
      chart: {
        ...chartConfig,
        paletteColors:
          '5D62B4,28C3BE,F27370,FFC532,61B58E,BC96DF,67CDF2,E58403,60CA9E,8F5097,569C3F,2797F1,BF5119,306004,32372E,5C97E0,2D6CA2,5B6770,8F6A2A,5F407A,872B4B,572C5F,244C5A,2596BE',
      },
      data: data,
    },
  };
};

export default function Donut2DChart({ chartConfig, height, data }) {
  return <ReactFC {...getChartConfig({ chartConfig, height, data })} />;
}
